import React from "react";

import { StyledSVG } from "../StyledIcon";

export const DiscussionIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M2.25 3.79911C2.25 3.16792 2.76167 2.65625 3.39286 2.65625H12.5821C13.2133 2.65625 13.725 3.16792 13.725 3.79911V9.90268C13.725 10.5339 13.2133 11.0455 12.5821 11.0455H4.99285C4.79339 11.0455 4.59739 11.0977 4.42436 11.197L2.25 12.4438V3.79911Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M15.75 8.26786C15.75 7.63667 15.2383 7.125 14.6071 7.125H7.51786C6.88667 7.125 6.375 7.63667 6.375 8.26786V13.0536C6.375 13.6848 6.88667 14.1964 7.51786 14.1964H13.4451C13.6498 14.1964 13.8508 14.2514 14.027 14.3557L15.75 15.375V8.26786Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </StyledSVG>
  );
};
